import ValidationUtils from './syllabusUtils/validationUtils';

export default ValidationUtils;
